import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import {
  dateReportFormatter
} from "../../fomatters/DateFormatter";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function UserDeleted() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [dateOf, setDateOf] = useState(0);
  const onDateOfChange = useCallback(
    (event) => setDateOf(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Date Of">
            <FormControl component="fieldset">
              <RadioGroup label value={dateOf} onChange={onDateOfChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Deleted"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Last Login"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="User Deleted Report"
        getUrl={() => "/Reports/Report_User_Deleted_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          DateOf: dateOf,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          Login Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="passWord">
          Password
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastLogin"
          dataFormat={dateReportFormatter}
        >
          Last Wager
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastModification"
          dataFormat={dateReportFormatter}
        >
          Deleted
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="profileName">
          Profile Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Department
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default UserDeleted;
